import request from '@/utils/http.js';

export const wechatShare = (data = {}) => {
  const url = '/v3/commons/auth/weixin-share';
  return request({
    url,
    method: 'POST',
    data
  });
};

const wwchatShare = (params) => {
  const url = '/v1/marketing/app/corp-application/get-config-signature';
  return request({
    url,
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  });

};

/**
 * (Web端)公众号-获取公众号信息
 * http://yapi.vhall.domain/project/1268/interface/api/58863
 * @param params
 * @returns {*}
 */
const wechatOaGetInfo = (params = {}) => {
  return request({
    url: '/v1/marketing/app/wechat-oa/get-info',
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

/**
 * http://yapi.vhall.domain/project/1265/interface/api/59521
 * 获取前端微信SDK初始化参数
 * @param params
 * @returns {*}
 */
export const wechatOaSdkSign = function (params) {
  return request({
    url: '/v1/marketing/app/wechat-oa/sdk-sign',
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

/**
 * 获取开启公众号通知模版id
 * @param {*} params
 * @returns
 */
export const getWechatOaNoticeTemplates = function (params) {
  return request({
    url: '/v1/marketing/app/wechat-notice/get-template-id',
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

/**
 * 微信公众号订阅通知授权保存
 * @param {*} params
 * @returns
 */
export const saveWechatOaSubscribe = (params = {}) => {
  return request({
    url: '/v1/marketing/app/wechat-notice/save-authorize-subscribe',
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  });
};


/***
 * 微信通知被点击后跳转到活动页时上报
 * @param {*} params
 * @returns
 */
export const reportWechatOaNoticeClick = function (params) {
  return request({
    url: '/v1/marketing/app/wechat-notice/click-template-report',
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

/**
 * 获取小程序二维码图片
 * @param {*} params
 * @returns
 */
export const fetchWxMiniprogramQrImage = function (params) {
  return request({
    url: '/v1/marketing/app/wxa/get-qr-image',
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}


export default {
  wwchatShare,
  wechatShare,
  wechatOaGetInfo,
  wechatOaSdkSign,
  getWechatOaNoticeTemplates,
  saveWechatOaSubscribe,
  reportWechatOaNoticeClick,
  fetchWxMiniprogramQrImage
};
